require('./tabs/tabs.scss');
var TabsModel = Backbone.Model.extend({
    defaults: {
        active: false
    }
});
var TabsCollection = Backbone.Collection.extend({
    model: TabsModel
});

var LabelBase = Marionette.ItemView.extend({
    tagName: 'li',
    modelEvents: {
        'change:active': 'render'
    },
    onRender: function () {
        this.$el.toggleClass('active', this.model.get('active'));
    },
    serializeData: function () {
        return {
            options: this.options,
            model: this.model.toJSON()
        };
    }
});

var DropdownLabel = LabelBase.extend({
    template: require('./tabs/tabs-dropdown-label.html'),
    className: 'tl-tabs-dropdown-label',
    triggers: function () {
        return {
            'click': {
                event: 'clicked',
                stopPropagation: false,
                preventDefault: true
            }
        };
    }
});

var TabsDropdown = Marionette.CompositeView.extend({
    template: require('./tabs/tabs-dropdown.html'),
    childView: DropdownLabel,
    childViewContainer: '.tl-dropdown-menu-container',
    tagName: 'li',
    className: 'tl-tabs-dropdown dropdown',
    childEvents: {
        'clicked': function (tabView) {
            this.trigger('dropdown:item:clicked', tabView.model);
        }
    },
    modelEvents: {
        'change:active': 'render'
    },
    _getBsDropdownToggle: function () {
        return jQuery(this.$el.find('.dropdown-toggle'));
    },
    onRender: function () {
        var self = this;
        self.$el.attr('role', 'presentation');
        self.$el.toggleClass('active', self.model.get('active'));
        var $dropdownToggle = self._getBsDropdownToggle();
        $dropdownToggle.dropdown();
        if (self.model.get('open')) {
            $dropdownToggle.dropdown('toggle');
        }
        jQuery(self.$el).on('show.bs.dropdown	', function () {
            self.model.set('open', true);
        });
        jQuery(self.$el).on('shown.bs.dropdown', function () {
            self.model.set('open', true);
        });
        jQuery(self.$el).on('hide.bs.dropdown', function () {
            self.model.set('open', false);
        });
        jQuery(self.$el).on('hidden.bs.dropdown', function () {
            self.model.set('open', false);
        });
    },
    serializeData: function () {
        return {
            options: this.options,
            model: this.model.toJSON()
        };
    }
});

var TabsLabel = LabelBase.extend({
    template: require('./tabs/tabs-label.html'),
    className: 'tl-tabs-label',
    triggers: function () {
        return {
            'click': {
                event: 'tab:clicked',
                stopPropagation: false,
                preventDefault: true
            }
        };
    },
    onRender: function () {
        this.$el.attr('role', 'presentation');
        this.$el.toggleClass('active', this.model.get('active'));
    }
});

var TabsLabels = Marionette.CollectionView.extend({
    childViewOptions: function (model, index) {
        return {
            collection: model.get('dropdown')
        };
    },
    childEvents: {
        'tab:clicked': function (tabsLabel) {
            this.trigger('tab:clicked', tabsLabel.model);
        },
        'dropdown:item:clicked': function (tabsLabel, model) {
            this.trigger('tab:clicked', model);
        }
    },
    getChildView: function (model) {
        if (model.get('dropdown')) {
            return TabsDropdown;
        } else {
            return TabsLabel;
        }
    },
    tagName: 'ul',
    className: function () {
        var classNames = ['tl-tabs-labels', 'nav'];
        switch (this.options.style) {
            case 'tabs':
                classNames.push('nav-tabs');
                break;
            case 'pills':
                classNames.push('nav-pills');
                break;
            default:
        }
        return classNames.join(' ');
    }
});

var Tabs = Marionette.LayoutView.extend({
    template: require('./tabs/tabs.html'),
    className: 'tl-tabs',
    regions: {
        tabsLabelsRegion: '.tl-tabs-labels-region'
    },
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {}, {
                style: 'pills' // pills | tabs
            }
        );

        if (!this.options.tabs) {
            throw new Error('tabs not supplied in options');
        }

        this.collection = new TabsCollection(this.options.tabs);
        this.collection.each(function (tabModel) {
            if (tabModel.get('dropdown')) {
                tabModel.set('dropdown', new TabsCollection(tabModel.get('dropdown')));
            }
        });
    },
    setActiveTabById: function (tabId) {
        var targetTab = this.collection.get(tabId);
        if (targetTab) {
            targetTab.set('active', true);
            this.setActiveTabByModel(targetTab);
        }
    },
    setActiveTabByModel: function (targetTab) {
        targetTab.collection.each(function (tabModel) {
            tabModel.set('active', tabModel === targetTab);
            if (tabModel.has('dropdown')) {
                tabModel.get('dropdown').each(function (dropdownTabModel) {
                    dropdownTabModel.set('active', dropdownTabModel === targetTab);
                });
            }
        });
    },
    onRender: function () {
        var self = this;
        var tabsLabels = new TabsLabels({
            collection: self.collection,
            style: self.options.style
        });
        tabsLabels.on('tab:clicked', function (model) {
            self.trigger('tab:clicked', model);
            self.trigger('tab:clicked:' + model.id);
            self.setActiveTabByModel(model);
        });
        self.tabsLabelsRegion.show(tabsLabels);
    }
});
module.exports = Tabs;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/tabs.js
 ** module id = 255
 ** module chunks = 1 2 3 7 30 33 46
 **/